module.exports = __webpack_public_path__ + "img/myposition_ss.4def6f12.svg";